import styled from 'styled-components'
import { DialogActions } from '@material-ui/core'

const StyledActionsDialog = styled(DialogActions)`
  && {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: 24px 20px 24px 20px;
    > * {
      margin: 0;
    }
  }
`

export default StyledActionsDialog
